import {
  Outlet,
  createRootRouteWithContext,
  useRouterState,
} from '@tanstack/react-router'
import { TanStackRouterDevtoolsPanel } from '@tanstack/react-router-devtools'
import { TanStackDevtools } from '@tanstack/react-devtools'
import TanStackQueryDevtools from '@/shared/lib/query/devtools'
import appCss from '@/styles.css?url'
import { Provider } from '@/app/providers/chakra-provider'
import type { QueryClient } from '@tanstack/react-query'
import { EnvBasedAlert } from '@/features/env-based-alert'
import type { AbilityStore, AuthStore, IAuthUser } from '@/shared'

interface MyRouterContext {
  queryClient: QueryClient
  user: IAuthUser | null
  authStore: AuthStore
  abilityStore: AbilityStore
}

export const Route = createRootRouteWithContext<MyRouterContext>()({
  head: () => ({
    meta: [
      {
        charSet: 'utf-8',
      },
      {
        name: 'viewport',
        content: 'width=device-width, initial-scale=1',
      },
      {
        title: 'Blood',
      },
    ],
    links: [
      {
        rel: 'stylesheet',
        href: appCss,
      },
    ],
  }),
  component: RootLayout,
})

function RootLayout() {
  const pathname = useRouterState({ select: (s) => s.location.pathname })
  // The auth entry screen is light-only — its background art is built for it,
  // and there is no color-mode toggle outside the protected header anyway.
  const forcedTheme = pathname.startsWith('/auth/entry') ? 'light' : undefined

  return (
    <Provider forcedTheme={forcedTheme}>
      <div>
        <EnvBasedAlert />
        <Outlet />
      </div>
      <TanStackDevtools
        config={{
          position: 'bottom-right',
        }}
        plugins={[
          {
            name: 'Tanstack Router',
            render: <TanStackRouterDevtoolsPanel />,
          },
          TanStackQueryDevtools,
        ]}
      />
    </Provider>
  )
}
